<template>
    <time class="cursor-pointer whitespace-no-wrap overflow-x-auto" :class="textSizeString" @click="isRelative = !isRelative">{{ displayDate }}</time>
</template>

<script>
import TextSizeable from "../../mixins/TextSizeable";

    export default {
        name: "DynamicDateRange",

        mixins: [TextSizeable],

        props: {

            start: {
                type: [String, Object],
                default: null
            },

            end: {
                type: [String, Object],
                default: null
            },

            // Whether to show the time on long format
            time: {
                type: Boolean,
                default: false
            },

            // Whether to show the time on long format when the time is not set to the start or end of day, i.e., 00:00 or 23:59
            specificTime: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                isRelative: true
            }
        },

        computed: {
            displayDate() {
                const dateFormat = this.isRelative ? 'L' : 'LL';
                const timeFormat = 'HH:mm';

                if (this.start && this.end) {
                    const startDate = this.$date(this.start);
                    const endDate = this.$date(this.end);
                    const startDateString = startDate.format(dateFormat);
                    const endDateString = endDate.format(dateFormat);
                    const startTimeString = this.time || this.specificTime ? startDate.format(timeFormat) : '';
                    const endTimeString = this.time || this.specificTime ? endDate.format(timeFormat) : '';

                    if (startDate.isSameDay(endDate)) {
                        if (!this.time && (!this.specificTime || (startTimeString === '00:00' && endTimeString === '23:59'))) {
                            return startDateString;
                        }

                        return `${startDateString} ${startTimeString} - ${endTimeString} Uhr`;
                    }

                    // Some users input 00:00 as end time but actually mean 23:59
                    if (!this.time && (!this.specificTime || (startTimeString === '00:00' && endTimeString === '00:00'))) {
                        return `${startDateString} - ${endDate.subtract(1, 'day').format(dateFormat)}`;
                    } else if (!this.time && (!this.specificTime || (startTimeString === '00:00' && endTimeString === '23:59'))) {
                        return `${startDateString} - ${endDateString}`;
                    }

                    return `${startDateString} ${startTimeString} Uhr - ${endDateString} ${endTimeString} Uhr`;
                }

                if (this.start) {
                    const startDate = this.$date(this.start);
                    const startDateString = startDate.format(dateFormat);
                    const startTimeString = this.time || this.specificTime ? startDate.format(timeFormat) : '';

                    if (!this.time && (!this.specificTime || startTimeString === '00:00')) {
                        return `${this.$t('conjunction.starting_at')} ${startDateString}`
                    }
                    return `${this.$t('conjunction.starting_at')} ${startDateString} ${startTimeString} Uhr`
                }

                if (this.end) {
                    const endDate = this.$date(this.end);
                    const endDateString = endDate.format(dateFormat);
                    const endTimeString = this.time || this.specificTime ? endDate.format(timeFormat) : '';

                    if (!this.time && (!this.specificTime || endTimeString === '00:00')) {
                        return `${this.$t('conjunction.until')} ${endDateString}`
                    }
                    return `${this.$t('conjunction.until')} ${endDateString} ${endTimeString} Uhr`
                }

                return '-';
            }
        }
    }
</script>